<template>
    <job-datatable v-if="!isMobile" />
    <job-mobile v-else :rows="rows" :total="total" @refresh="loadData" @new-record="newRecord" @edit-record="editRecord" />
    <router-view name="modal"></router-view>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter, RouterView } from "vue-router";
import Api, { ApiResponse } from "@/services/ApiService";
import type { RequestModel } from "@/models/RequestModel";
import JobDatatable from "@/components/Jobs/JobDatatable.vue";
import JobMobile from "@/components/Jobs/JobMobile.vue";

const router = useRouter();
const isMobile = ref(false);
let mediaQuery: MediaQueryList | null = null;

onMounted(() => {
    if (typeof window !== 'undefined') {
        mediaQuery = window.matchMedia('(max-width: 767px)');
        isMobile.value = mediaQuery.matches;
        mediaQuery.addEventListener('change', (e: MediaQueryListEvent) => { isMobile.value = e.matches; });
        if (isMobile.value) { loadData(); }
    }
});

onUnmounted(() => { if (mediaQuery) { mediaQuery.removeEventListener('change', (e: any) => {}); } });

const total = ref(0);
const rows = ref<RequestModel[]>([]);

const loadData = async () => {
    try {
        const params: any = { Page: 0, Size: 100, IncludeContact: true, ExcludePMRequests: true };
        const response: ApiResponse<RequestModel[]> = await Api.loadRequests(params);
        rows.value = response.Data || [];
        total.value = response.Meta?.Total || 0;
    } catch (error) {
        console.error('Failed to load data:', error);
        rows.value = []; total.value = 0;
    }
};

const newRecord = () => { router.push({ path: "/job/new" }); };
const editRecord = (id: number) => { router.push({ path: "/job/edit/" + id }); };
</script>
